var map = {
	"./de.json": [
		35016,
		5016
	],
	"./en.json": [
		82388,
		2388
	],
	"./fr.json": [
		32471,
		2471
	],
	"./it.json": [
		13306,
		3306
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4211;
module.exports = webpackAsyncContext;